import {FileUploadStoreOptions} from '@common/uploads/uploader/file-upload-store';
import {getActiveWorkspaceId} from '@common/workspace/active-workspace-id';

export const uploadStoreOptions: FileUploadStoreOptions = {
  modifyUploadedFile: uploadedFile => {
    const workspaceId = getActiveWorkspaceId();
    uploadedFile.fingerprint = `${uploadedFile.fingerprint}-w-${workspaceId}`;
    return uploadedFile;
  },
};